import { inject } from "@angular/core";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { catchError, map, of, pipe, switchMap } from "rxjs";
import { CommonApiService } from "src/app/services/common-api.service";
import { API } from "../../models/api.enum";
import { ILogoutRes, ILogoutState } from "../../models/logout.models";

const initialState: ILogoutState = {
  data: null,
  isLoading: false,
  error: null,
};

export const LogoutStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store, commonApiService = inject(CommonApiService)) => ({
    logout: rxMethod<void>(
      pipe(
        switchMap(() => {
          patchState(store, (state) => ({
            ...state,
            data: null,
            isLoading: true,
            error: null,
          }));
          return commonApiService.post<ILogoutRes>(API.LOGOUT, undefined).pipe(
            map((data) =>
              patchState(store, (state) => ({
                ...state,
                data,
                isLoading: false,
              })),
            ),
            catchError((error) =>
              of(
                patchState(store, (state) => ({
                  ...state,
                  isLoading: false,
                  error,
                })),
              ),
            ),
          );
        }),
      ),
    ),
    clearStore() {
      patchState(store, () => ({ ...initialState }));
    },
  })),
);
